import { X } from "lucide-react";

export type ModalComponentProps = {
    id: string;
    title?: string;
    open?: boolean;
    onClose?: () => void;
    children?: React.ReactNode;
};

export default function Modal({id, title, open, onClose, children}: ModalComponentProps) {
    return (
        <>
        <input readOnly type="checkbox" checked={open} className="modal-toggle"/>
        <div className="modal">
            <div className="modal-box p-2">
                <div className="flex items-center">
                    <div className="flex-1">
                        <p>{title}</p>
                    </div>
                    <div className="flex-none">
                        <button onClick={onClose} className="btn btn-xs btn-ghost"><X size={16} /></button>
                    </div>
                </div>

                {children}
            </div>

            <label onClick={onClose} className="modal-backdrop"></label>
        </div>
        </>
    );
}